// Copyright 2021 Rennie Glen Software LL
import cutterMarksSvg from "../assets/img/cutter-marks.svg";
import toggleLayersSvg from "../assets/img/toggle-layers.svg";
import makeBleedsSvg from "../assets/img/make-bleeds.svg";
import gangSvg from "../assets/img/gang.svg";
import expertSvg from "../assets/img/expert.svg";
import rotatePing from "../assets/img/rotate.png";
import nupPing from "../assets/img/nup.png";
import monkeyPing from "../assets/img/monkey.png";
import resizePing from"../assets/img/resize.png";
import cropPing from "../assets/img/crop.png";
import shufflePing from "../assets/img/shuffle.png";
import bookletPing from "../assets/img/booklet.png";
import nupBookPing from "../assets/img/nupbook.png";
import cardsPing from "../assets/img/cards.png";
import flipPing from "../assets/img/flip.png";
import splitPing from "../assets/img/split.png";
import overlayPing from "../assets/img/overlay.png";
import nudgePing from "../assets/img/nudge.png";
import headerFooterPing from "../assets/img/header-footer.png";
import colorBarPing from "../assets/img/colorbar.svg";
import nestPing from "../assets/img/nest.png";
import calendarPing from "../assets/img/calendar.png";
import insertPagesPing from "../assets/img/insertpages.png";
import maskingTapeSvg from "../assets/img/masking-tape.svg";

/**
 * The basic operations that all steps are composed from.
 * 
 * Listed in the order that we want them to appear in the help, when choosing an
 * op, etc.
 */
export enum Operation {
    Cards = "Cards",
    Book = "Booklet",
    MakeBleeds = "MakeBleeds",
    Resize = "Resize",
    Grid = "Grid",
    NupBook = "NupBook",
    Monkey = "Monkey",
    Crop = "Crop",
    Rotate = "Rotate",
    Overlay = "Overlay",
    InsertPages = "InsertPages",
    HeaderFooter = "HeaderFooter",
    Expert = "Expert",
    Shuffle = "Shuffle",
    Nudge = "Nudge",
    CutterMarks = "CutterMarks",
    Split = "Split",
    Nest = "Nest",
    ColorBar = "ColorBar",
    ToggleLayers = "ToggleLayers",
    Flip = "Flip",
    Gang = "Gang",
    Calendar = "Calendar",
    MaskingTape = "MaskingTape",
}

export function getOpFromQueryString(queryString: string | null | (string | null)[]): Operation | null {
    const strings = typeof(queryString) === 'string' ? [ queryString ] : queryString ?? [];
    for (const s of strings) {
        const maybeOp = s as Operation;
        if (Object.values(Operation).includes(maybeOp)) {
            return maybeOp;
        }
    }
    return null;
}

export function thumbnailUrlForOp(op: Operation): string {
    switch (op) {
        case Operation.Rotate:
            return rotatePing;
        case Operation.Grid:
            return nupPing;
        case Operation.Monkey:
            return monkeyPing;
        case Operation.Resize:
            return resizePing;
        case Operation.Crop:
            return cropPing;
        case Operation.Shuffle:
            return shufflePing;
        case Operation.Book:
            return bookletPing;
        case Operation.NupBook:
            return nupBookPing;
        case Operation.Cards:
            return cardsPing;
        case Operation.Flip:
            return flipPing;
        case Operation.Split:
            return splitPing;
        case Operation.Overlay:
            return overlayPing;
        case Operation.Nudge:
            return nudgePing;
        case Operation.HeaderFooter:
            return headerFooterPing;
        case Operation.ColorBar:
            return colorBarPing;
        case Operation.Nest:
            return nestPing;
        case Operation.Calendar:
            return calendarPing;
        case Operation.InsertPages:
            return insertPagesPing;
        case Operation.Gang:
            return gangSvg;
        case Operation.CutterMarks:
            return cutterMarksSvg;
        case Operation.MaskingTape:
            return maskingTapeSvg;
        case Operation.ToggleLayers:
            return toggleLayersSvg;
        case Operation.Expert:
            return expertSvg;
        case Operation.MakeBleeds:
            return makeBleedsSvg;
    }
}

export function opName(t: (key: string) => string, op: Operation): string {
    switch (op) {
      case Operation.Book:
        return t("tools.booklet").toString();
      case Operation.Grid:
        return t("tools.grid").toString();
      case Operation.Monkey:
        return t("tools.monkey").toString();
      case Operation.Resize:
        return t("tools.resize").toString();
      case Operation.Rotate:
        return t("tools.rotate").toString();
      case Operation.Crop:
        return t("tools.crop").toString();
      case Operation.Shuffle:
        return t("tools.shuffle").toString();
      case Operation.Cards:
        return t("tools.cards").toString();
      case Operation.Flip:
        return t('tools.flip').toString();
      case Operation.NupBook:
        return t('tools.nupBook').toString();
      case Operation.Split:
        return t('tools.split').toString();
      case Operation.Overlay:
        return t('tools.overlay').toString();
      case Operation.Nudge:
        return t('tools.nudge').toString();
      case Operation.HeaderFooter:
        return t('tools.headerFooter').toString();
      case Operation.ColorBar:
        return t('tools.colorBar').toString();
      case Operation.Nest:
        return t("tools.nest").toString();   
      case Operation.Calendar:
        return t("tools.calendar").toString();
      case Operation.InsertPages:
        return t("tools.insertPages").toString();
      case Operation.Gang:
        return t("tools.gang").toString();
      case Operation.CutterMarks:
        return t("tools.cutterMarks").toString();
      case Operation.MaskingTape:
        return t("tools.maskingTape").toString();
      case Operation.ToggleLayers:
        return t("tools.layers").toString();
      case Operation.Expert:
        return t('tools.expert');
      case Operation.MakeBleeds:
        return t('tools.makeBleeds');
      }
  }
  
  export function opMergesFiles(op: Operation): boolean {
    switch (op) {
      case Operation.Gang:
      case Operation.Nest:
        return true;
      default:
        return false;
    }
  }